import { fromJS } from 'immutable';

import { CDN_ASSETS } from '../../../../constants/common';

const initialState = fromJS({
  'packages/fortuna-room.jpg': `${CDN_ASSETS}/packages/fortuna/fortuna-room.jpg`,
  'packages/fortuna-room@2x.jpg': `${CDN_ASSETS}/packages/fortuna/fortuna-room@2x.jpg`,
  'packages/fortuna-room@3x.jpg': `${CDN_ASSETS}/packages/fortuna/fortuna-room@3x.jpg`,

  'packages/fortuna.jpg': `${CDN_ASSETS}/packages/fortuna/fortuna.jpg`,
  'packages/fortuna@2x.jpg': `${CDN_ASSETS}/packages/fortuna/fortuna@2x.jpg`,
  'packages/fortuna@3x.jpg': `${CDN_ASSETS}/packages/fortuna/fortuna@3x.jpg`,

  'packages/fortuna-2.jpg': `${CDN_ASSETS}/packages/fortuna/fortuna-2.jpg`,
  'packages/fortuna-2@2x.jpg': `${CDN_ASSETS}/packages/fortuna/fortuna-2@2x.jpg`,
  'packages/fortuna-2@3x.jpg': `${CDN_ASSETS}/packages/fortuna/fortuna-2@3x.jpg`,
});

export default function (state = initialState, action) {
  switch (action.type) {
    default:
      return state;
  }
}
